import React from "react";
import { gsap } from "gsap";
import { useLayoutEffect } from "react";
import { useRef } from "react";
import styles from "./FlexibleKPI.module.scss";
import bubble from "../../img/flexibleKPI/bubble.png";
import beachBall from "../../img/flexibleKPI/beachBall.png";
import redBall from "../../img/flexibleKPI/redBall.png";
import sunglasses from "../../img/flexibleKPI/sunglasses.png";

const FlexibleKPI = ({ flexibleKpiRef }) => {
  const topBubbleRef = useRef();
  const beachBallRef = useRef();
  const redBallRef = useRef();
  const sunglassesRef = useRef();
  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add(
        "(min-width: 1441px)",
        () => {
          gsap.fromTo(
            topBubbleRef.current,
            {
              top: "-100px",
            },
            {
              top: "105px",
              scrollTrigger: {
                trigger: flexibleKpiRef.current,
                start: "top 75%",
                end: "bottom bottom",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 2,
            }
          );
        },
        topBubbleRef
      );
      gsap.matchMedia().add(
        "(min-width: 769px) and (max-width: 1440px)",
        () => {
          gsap.fromTo(
            topBubbleRef.current,
            {
              top: "0vw",
            },
            {
              top: "7.29vw",
              scrollTrigger: {
                trigger: flexibleKpiRef.current,
                start: "top 75%",
                end: "center cetner",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        topBubbleRef
      );
      gsap.matchMedia().add(
        "(min-width: 481px) and (max-width: 768px)",
        () => {
          gsap.fromTo(
            topBubbleRef.current,
            {
              top: "0vw",
            },
            {
              top: "10.94vw",
              scrollTrigger: {
                trigger: flexibleKpiRef.current,
                start: "top 75%",
                end: "center cetner",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        topBubbleRef
      );

      gsap.matchMedia().add(
        "(max-width: 480px)",
        () => {
          gsap.fromTo(
            topBubbleRef.current,
            {
              top: 0,
              duration: 4,
            },
            {
              top: "29.38vw",
              scrollTrigger: {
                trigger: flexibleKpiRef.current,
                start: "top 75%",
                end: "20% 13%",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        topBubbleRef
      );
    });
    return () => ctx.revert();
  });

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add(
        "(min-width:1441px)",
        () => {
          gsap.fromTo(
            beachBallRef.current,
            {
              top: "-150px",
              duration: 2,
            },
            {
              top: "141px",
              scrollTrigger: {
                trigger: beachBallRef.current,
                start: "top 75%",
                end: "center center",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 2,
            }
          );
        },
        beachBallRef
      );

      gsap.matchMedia().add(
        "(min-width:769px) and (max-width:1440px)",
        () => {
          gsap.fromTo(
            beachBallRef.current,
            {
              top: "0vw",
            },
            {
              opacity: 1,
              top: "9.79vw",
              scrollTrigger: {
                trigger: beachBallRef.current,
                start: "top 75%",
                end: "center cetner",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        beachBallRef
      );

      gsap.matchMedia().add(
        "(min-width: 481px) and (max-width: 768px)",
        () => {
          gsap.fromTo(
            beachBallRef.current,
            {
              top: "0vw",
            },
            {
              top: "14.19vw",
              // ease: 3,
              scrollTrigger: {
                trigger: beachBallRef.current,
                start: "top 75%",
                end: "center cetner",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        beachBallRef
      );

      gsap.matchMedia().add(
        "(max-width: 480px)",
        () => {
          gsap.fromTo(
            beachBallRef.current,
            {
              top: "0vw",
            },
            {
              top: "33.33vw",
              // ease: 3,
              scrollTrigger: {
                trigger: beachBallRef.current,
                start: "top 75%",
                end: "center cetner",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        beachBallRef
      );
    });
    return () => ctx.revert();
  });
  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add(
        "(min-width:1441px)",
        () => {
          gsap.fromTo(
            redBallRef.current,
            {
              bottom: "0px",
              duration: 2,
            },
            {
              bottom: "121px",
              scrollTrigger: {
                trigger: flexibleKpiRef.current,
                start: "top top",
                end: "bottom bottom",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 2,
            }
          );
        },
        redBallRef
      );

      gsap.matchMedia().add(
        "(min-width:769px) and (max-width:1440px)",
        () => {
          gsap.fromTo(
            redBallRef.current,
            {
              bottom: "0vw",
              duration: 5,
            },
            {
              bottom: "8.4vw",
              scrollTrigger: {
                trigger: flexibleKpiRef.current,
                start: "-10% top",
                end: "30% 35%",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 5,
            }
          );
        },
        redBallRef
      );

      gsap.matchMedia().add(
        "(min-width: 481px) and (max-width: 768px)",
        () => {
          gsap.fromTo(
            redBallRef.current,
            {
              bottom: "83vw",

              duration: 5,
            },
            {
              bottom: "89.06vw",
              scrollTrigger: {
                trigger: flexibleKpiRef.current,
                start: "-10% top",
                end: "30% 35%",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 5,
            }
          );
        },
        redBallRef
      );

      gsap.matchMedia().add(
        "(max-width: 480px)",
        () => {
          gsap.fromTo(
            redBallRef.current,
            {
              bottom: "0vw",
              duration: 5,
            },
            {
              bottom: "19.38vw",
              scrollTrigger: {
                trigger: flexibleKpiRef.current,
                start: "30% 30%",
                end: "50% 35%",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 5,
            }
          );
        },
        redBallRef
      );
    });
    return () => ctx.revert();
  });

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add("(min-width:1441px)", () => {
        gsap.fromTo(
          sunglassesRef.current,
          {
            bottom: "-100px",
            duration: 4,
          },
          {
            bottom: "33px",
            scrollTrigger: {
              trigger: flexibleKpiRef.current,
              start: "center 70%",
              end: "bottom bottom",
              scrub: true,
              snap: false,
              pinSpacing: false,
              markers: false,
            },
            duration: 4,
          }
        );
      });
      gsap.matchMedia().add("(min-width:769px) and (max-width:1440px)", () => {
        gsap.fromTo(
          sunglassesRef.current,
          {
            bottom: "-5vw",
            duration: 4,
          },
          {
            bottom: "2.29vw",
            scrollTrigger: {
              trigger: flexibleKpiRef.current,
              start: "center 55%",
              end: "bottom bottom",
              scrub: true,
              snap: false,
              pinSpacing: false,
              markers: false,
            },
            duration: 4,
          }
        );
      });
      gsap.matchMedia().add(" (max-width:768px)", () => {
        gsap.fromTo(
          sunglassesRef.current,
          {
            bottom: "10vw",
            duration: 4,
          },
          {
            bottom: "14.19vw",
            scrollTrigger: {
              trigger: flexibleKpiRef.current,
              start: "70% 80%",
              end: "80% 70%",
              scrub: true,
              snap: false,
              pinSpacing: false,
              markers: false,
            },
            duration: 4,
          }
        );
      });
    }, sunglassesRef);
    return () => ctx.revert();
  });
  return (
    <div className={styles.container} ref={flexibleKpiRef}>
      <div className={styles.contents_box}>
        <h1 className={styles.flexible_kpi_title} data-content="Flexible KPIs">
          Flexible KPIs
        </h1>
        <div className={styles.flexible_kpi_context}>
          Don’t miss out on the incredible opportunity to create and publish
          games with Flexible KPIs! Meet your unique goals more easily and have
          the chance to compete for lots of cash rewards and interesting prizes.
        </div>
        <img
          className={styles.bubble}
          src={bubble}
          alt="bubble"
          ref={topBubbleRef}
        />
        <img
          className={styles.beachball}
          src={beachBall}
          alt="beachBall"
          ref={beachBallRef}
        />
        <img
          className={styles.redball}
          src={redBall}
          alt="redball"
          ref={redBallRef}
        />
        <img
          className={styles.sunglasses}
          src={sunglasses}
          alt="bubble"
          ref={sunglassesRef}
        />
      </div>
    </div>
  );
};

export default FlexibleKPI;
